function Configurator() {
  return null;
}

export default Configurator;
